// extracted by mini-css-extract-plugin
export var border = "_q-7";
export var brand = "_q-r";
export var button = "_q-j";
export var center = "_q-9";
export var centered = "_q-5";
export var closeButton = "_q-b";
export var disabledWrapper = "_q-k";
export var error = "_q-n";
export var extraLarge = "_q-4";
export var extraSmall = "_q-1";
export var fill = "_q-g";
export var footer = "_q-f";
export var footerAction = "_q-h";
export var footerButtons = "_q-i";
export var header = "_q-6";
export var icon = "_q-m";
export var info = "_q-q";
export var inline = "_q-8";
export var large = "_q-3";
export var main = "_q-c";
export var modal = "_q-0";
export var neutral = "_q-s";
export var noPadding = "_q-e";
export var none = "_q-t";
export var scrollable = "_q-d";
export var small = "_q-2";
export var success = "_q-p";
export var tight = "_q-l";
export var titleIcon = "_q-a";
export var warn = "_q-o";